export default __webpack_public_path__ + "static/media/icon-arrow.759c4f6a.svg";